module.exports = require('./helpers/bundle-url').getBundleURL('7JE76') + "brown_photostudio_04_8k.feb12b39.hdr" + "?" + Date.now();